import { faChevronLeft, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

const ToBack = (props) => {
  // const { report, complaint, dataId, dataType, search } = props;
  const { refresh, resumeId, resumeUUid } = props;

  const toPrevious = () => {
    if (props.handleBack) {
      props.handleBack();
    }
    if (props.href) {
      location.href = props.href;
    } else {
      history.back();
    }
  };

  const refresh_btn = () => {
    // const auth = JSON.parse(localStorage.getItem('auth'));
    // fetch(`/api/resume/${auth.id}?option=refresh`, {
    //   method: 'PUT',
    //   headers: { 'content-type': 'application/json' },
    //   body: JSON.stringify({}),
    // })
    fetch(`/gin-api/resume/${resumeUUid}/${resumeId}?option=refresh`, {
      method: "PATCH",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({}),
    }).then((res) => {
      if (res.status !== 200) {
        return;
      }
      alert("刷新成功，您的简历会更容易被企业HR看到！");
    });
  };

  return (
    <div className="row pl-2 pt-3 pr-2" style={{ paddingBottom: 15 }}>
      <div className="col">
        <span onClick={toPrevious} className="text-dark toback-line" aria-hidden="true">
          <FontAwesomeIcon icon={faChevronLeft} size="lg" fixedWidth />
          &nbsp;&nbsp;&nbsp;&nbsp;
          {/* {props.category} */}
        </span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="#/" style={{ color: "#323a40" }}>
          <FontAwesomeIcon icon={faHome} size="lg" fixedWidth />
        </a>
      </div>
      {refresh && (
        <button
          className="text-success bg-transparent border-0 pr-4"
          style={{ fontSize: 18 }}
          onClick={refresh_btn}
        >
          刷新
        </button>
      )}
      {/* {(report || complaint) && (
        <div className="col flex-end">
          {report && (
            <a className="text-danger" href={`#/我的/举报/${dataId}/${dataType}${search}`}>
              举报
            </a>
          )}
          {complaint && (
            <a className="text-danger" href="#/举报">
              投诉
            </a>
          )}
        </div>
      )} */}
    </div>
  );
};

ToBack.propTypes = {
  // report: PropTypes.bool,
  refresh: PropTypes.bool,
  resumeId: PropTypes.number,
  resumeUUid: PropTypes.string,
  handleBack: PropTypes.func,
  // complaint: PropTypes.string,
  href: PropTypes.string,
  // dataId: PropTypes.string,
  // dataType: PropTypes.string,
  // search: PropTypes.string,
};

ToBack.defaultProps = {
  // report: undefined,
  handleBack: undefined,
  // complaint: undefined,
  href: undefined,
  // dataId: undefined,
  // dataType: undefined,
  // search: undefined,
};

export default ToBack;
